import { cn } from '#/utils/cn';

interface SpinnerProps {
  className?: string;
  label?: string;
  size?: number;
}

export function Spinner({
  className,
  label = 'Loading…',
  size = 32,
}: SpinnerProps) {
  return (
    <div
      className={cn('flex w-full items-center justify-center py-8', className)}
      role="status"
    >
      <svg
        className="text-blue-70 animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  );
}
